import { RichiestaDTO } from '@framework/api-client';
import React from 'react';

export interface ContentCardWrapperProps {
  submission?: RichiestaDTO | null;
  children?: React.ReactNode;
}

/**
 * Wrapper
 */
export function ContentCardWrapper(props: ContentCardWrapperProps) {
  const { children } = props;

  return <>{children}</>;
}
